import type { AccountInfo } from '@azure/msal-browser';

import type { UserType } from '../types';

export function convertMsalAccountToUser(msalAccount: AccountInfo): UserType {
  const user: UserType = {
    id: msalAccount.localAccountId,
    email: msalAccount.username,
    displayName: msalAccount.name || '',
  };

  if (typeof msalAccount.idTokenClaims?.phone_number === 'string') {
    user.phoneNumber = msalAccount.idTokenClaims?.phone_number;
  }

  if (typeof msalAccount.idTokenClaims?.photo_url === 'string') {
    user.photoURL = msalAccount.idTokenClaims?.photo_url;
  }

  // TODO: Claims/etc into the user object
  // ...

  return user;
}
